import { useFormContext } from 'react-hook-form';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';
import type { GeneralFormProps } from '@/types/general';

import { Checkbox } from '../ui/checkbox';

function RHFShadcnCheckbox({
  name,
  title,
  description,
  value: externalValue,
  required,
  onChange: externalOnChange,
  disabled,
}: GeneralFormProps) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        const checkboxId = `checkbox-${field.name.replace(/\./g, '-')}`;

        return (
          <FormItem className="flex flex-row items-center gap-3 space-y-0">
            <FormControl>
              <Checkbox
                id={checkboxId}
                disabled={disabled}
                required={required}
                data-testid={field.name}
                className={disabled === true ? 'cursor-not-allowed opacity-50' : ''}
                onCheckedChange={(e) => {
                  if (externalOnChange !== undefined) {
                    externalOnChange(e);
                    return;
                  }
                  field.onChange(e);
                }}
                checked={field.value !== undefined ? field.value : externalValue}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel
                htmlFor={checkboxId}
                className={disabled === true ? 'cursor-not-allowed' : 'cursor-pointer'}
              >
                {title}
              </FormLabel>
              {description !== undefined && <FormDescription>{description}</FormDescription>}
            </div>
          </FormItem>
        );
      }}
    />
  );
}

export default RHFShadcnCheckbox;
